import {Button, Image} from "antd";
import {StyledCoverImagesItemImageWrapper, StyledCoverImagesItemWrapper} from "./styles";
import {OfferingFormCoverImagesItemProps} from "./types";
import {DeleteOutlined} from "@ant-design/icons";

export function OfferingFormCoverImagesItem({
  deleteFunction,
  imgSrc,
  isDeleteLoading,
  uploadStatus,
}: OfferingFormCoverImagesItemProps) {
  return (
    <StyledCoverImagesItemWrapper>
      <StyledCoverImagesItemImageWrapper>
        <Image
          style={{
            borderRadius: "4px",
            objectFit: "cover",
          }}
          width={"100%"}
          height={"100%"}
          src={imgSrc}
        />
      </StyledCoverImagesItemImageWrapper>
      {(uploadStatus === "pending" || uploadStatus === "success") && (
        <div>
          <Button
            loading={isDeleteLoading}
            onClick={deleteFunction}
            size="small"
            type="text"
            icon={<DeleteOutlined />}
          />
        </div>
      )}
    </StyledCoverImagesItemWrapper>
  );
}
